module.exports = __webpack_public_path__ + "media/images/mountains-3607bff671500ea97c9ca0679c08d742.svg";